import { Layer } from '@/declarations/layer';

export interface IOptions {
  alpha?: number;
  brightness?: number;
  hue?: number;
  saturation?: number;
  gamma?: number;
  contrast?: number;
}

export default abstract class EngineBase {
  engine: any;
  layers: string[];
  centerMaker: any;

  constructor(engine) {
    this.engine = engine;
    this.layers = [];
  }

  abstract setBaseMap(url: string): void;
  abstract addLayer(layer: Layer): void;
  abstract removeLayer(url: string): void;
  abstract updateLayer(index: number, key: keyof IOptions, val: number): void;
  abstract moveLayer(from: number, to: number): void;
  abstract setCenter(lng: number, lat: number): void;
  abstract getCenter(): number[];
  abstract setBBox(bbox: number[]): void;
  abstract showCenterMarker(bbox: number[]): void;
  abstract hideCenterMarker(): void;
}
